---
description: Thin flex webs that survive thousands of bends — web thickness, orientation along layers, material choice, break-in. Load for flip caps, cases and packaging that bend instead of jointing.
---

Related: pip-hinge for pinned rotation; this skill bends the plastic itself. Needs fit-clearance and printability-design numbers.

Web: thin central web (typically 0.3-0.8 for FDM PLA/PETG, tuned per filament) with generous blend radii into both leaves — sharp transitions crack on the first fold. Keep the web short along the bend, long across the width for even flex. Support both leaves flat on the bed where possible.

Orientation: hinge axis in the XY plane so bending runs along layer lines, never across Z layer bonds. Bending across layers delaminates instead of flexing.

Material: PETG, PP and co-polyester for hundreds to thousands of cycles; PLA for prototypes and single-digit folds (stiff, fatigues, creeps under held load). Nylon for 10k+ production cycles — SLS PA12 ideal, FDM must print dry.

Break-in: flex gently to full range a few times after full cool-down; stop at first whitening and thicken the web.

Coupon: single-hinge strip, not the product. Cycle target 20-30 folds for PETG latches, more for production claims. Whitening means too thin or wrong orientation; stiffness-crack means wrong material. Verify with measure/check.

Sources: printforge living hinge, 3dprinterstuff living hinges, vprint3d hinge checklist.
